import { extendTailwindMerge } from 'tailwind-merge'
import { ClassValue, clsx } from 'clsx'

const customTwMerge = extendTailwindMerge({})

export function cn (...inputs: ClassValue[]): string {
  return customTwMerge(clsx(inputs))
}
